module.exports = __webpack_public_path__ + "img/图片2.a6718caf.png";